<div *ngFor="let step of steps; let i = index" class="action-item">
  <button
    class="action-button"
    [ngClass]="{
      active: !isStepCompleted(step.key) && isStepAvailable(step.key),
      completed: isStepCompleted(step.key)
    }"
    [disabled]="!isStepAvailable(step.key)"
    (click)="isStepAvailable(step.key) && step.action()">
    <span>{{ step.label }}</span>
    <i
      class="bi icon"
      [ngClass]="
        isStepCompleted(step.key) ? 'bi-check-circle-fill' : step.icon
      "></i>
  </button>

  <button
    *ngIf="step.key === 'takeQuiz' && isStepCompleted(step.key)"
    class="btn btn-reset ms-2"
    (click)="viewQuizSubmission()"
    title="View Quiz Submission"
    ngbTooltip="View Quiz Submission">
    <i class="bi bi-eye text-primary"></i>
  </button>
</div>

<app-modal
  #viewQuizSubmissionModal
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    options: { size: 'lg' },
    titleText: 'View Quiz Submission',
    showFooter: false
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="viewQuizSubmissionModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="px-5 py-4" *ngIf="userQuizSubmission && quizId">
    <app-proforms-form
      [formId]="quizId"
      [submissionId]="userQuizSubmission.id"
      [viewState]="viewStates.GRADED" />
  </div>
</app-modal>

<app-modal
  #takeQuizModal
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    options: { size: 'lg' },
    titleText: 'Take Quiz',
    showFooter: false
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="takeQuizModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="px-5 py-4" *ngIf="quizId && sessionId">
    <app-proforms-form
      #takeQuizForm
      (formSubmitted)="submitQuiz($event)"
      (showGradedQuiz)="openGradedQuizModal($event)"
      [formId]="quizId"
      [context]="contextType"
      [contextId]="sessionId"
      [viewState]="viewStates.EDIT" />
  </div>
</app-modal>

<app-modal
  #takeSurveyModal
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    options: { size: 'lg' },
    titleText: 'Take Survey',
    showFooter: false
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="takeSurveyModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="px-5 py-4" *ngIf="surveyId && sessionId">
    <app-proforms-form
      (formSubmitted)="markStepCompleted('takeSurvey')"
      [formId]="surveyId"
      [context]="contextType"
      [contextId]="sessionId"
      [viewState]="viewStates.EDIT" />
  </div>
</app-modal>

<app-modal
  #gradedQuizModal
  (isDismissing)="gradedQuizModal.close()"
  [modalConfig]="{
  headerClass: ['modal-header', 'bg-primary', 'text-white'],
  customFooter: true,
  showFooter: false,
  titleText: 'View Graded Quiz',
  options: {
    size: 'lg',
  }
}">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="gradedQuizModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="px-5 py-4">
    <app-proforms-form
      *ngIf="gradedFormId && gradedSubmissionId"
      [formId]="gradedFormId"
      [submissionId]="gradedSubmissionId"
      [viewState]="viewStates.GRADED">
    </app-proforms-form>
  </div>
</app-modal>
